import {
  DOCUMENT_MAX_THUMBNAIL_WIDTH,
  DOCUMENT_THUMBNAIL_BORDER_OFFSET_PX,
} from 'constants/documents';

export const THUMBNAIL_HEIGHT = 185;
export const FULL_HEIGHT = 792;
export const THUMBNAIL_WIDTH = 186;
export const FULL_WIDTH = 612;

const THUMBNAIL_MIN_HEIGHT = 140;

export const THUMBNAIL_BORDER_WIDTH = DOCUMENT_THUMBNAIL_BORDER_OFFSET_PX / 2;
export const THUMBNAIL_MAX_CONTENT_WIDTH =
  DOCUMENT_MAX_THUMBNAIL_WIDTH - DOCUMENT_THUMBNAIL_BORDER_OFFSET_PX;
export const THUMBNAIL_MIN_CONTENT_HEIGHT =
  THUMBNAIL_MIN_HEIGHT - DOCUMENT_THUMBNAIL_BORDER_OFFSET_PX;

export const HALF_TURN_DEGREES = 180;

// pdf.js viewer defaults (PDFPageView maxCanvasPixels). iOS <= 17 rejects canvases over 2^24 px
// and iOS <= 16 caps total canvas memory, so touch devices get the lower budget.
export const MAX_CANVAS_PIXELS_DESKTOP = 33554432;
export const MAX_CANVAS_PIXELS_MOBILE = 5242880;
export const MAX_CANVAS_DIMENSION = 32767;
export const MAX_PAGE_OUTPUT_SCALE = 3;
export const MAX_THUMBNAIL_OUTPUT_SCALE = 2;
export const MAX_THUMBNAIL_OUTPUT_SCALE_MOBILE = 1;
// A Letter thumbnail at 2x is 356 x 461 = 164,116 px; the headroom keeps float rounding from
// trimming it below 2x. Caps 300 thumbnails at <= 189 MiB for any page size.
export const MAX_THUMBNAIL_CANVAS_PIXELS = 165000;

export const PDF_CARD_ERROR_MESSAGE = 'Could not get PDF';

export const CANVAS_CONTEXT_ATTRIBUTES = { willReadFrequently: true, alpha: false };

export const RELEASED_CANVAS_SIZE = { width: 1, height: 1 };
